export default __webpack_public_path__ + "static/media/course-img.4e5693c7.png";